<template>
    <v-img :src="khlogo" contain height="95px"></v-img> 
</template>

<script>

export default {

  props: ['khstadt', 'khstadtobj'],
  computed: {
    khlogo: function () {
      var khlogo
      switch (this.khstadt) {
        case 'Essen':
          khlogo = '/uploads/KH/KHlogo_header_essen_website.png'
          break
        case 'Mettmann':
          khlogo = '/uploads/KH/kh_mettmann_logo.jpg'
          break
        case 'Mülheim':
          khlogo = '/uploads/KH/mo_kh_logo.jpg'
          break
        case 'Kleve':
          khlogo = '/uploads/KH/kleve_kh_logo_q.png'
          break
        case 'Duisburg':
          khlogo = '/uploads/KH/kh_duisburg_logo.jpg'
          break
        case 'Recklinghausen':
          khlogo = '/uploads/KH/KHRE-Logo-Banner_rgb-01.png'
          break
        case 'Düsseldorf':
          khlogo = '/uploads/KH/kh_dusseldorf_logo.png'
          break
        case 'Münster':
          khlogo = '/uploads/KH/kh_münster_logo.png'
          break
        case 'Ruhr':
          khlogo = '/uploads/KH/kh_ruhr_logo2.png'
          break
        case 'Coesfeld':
          khlogo = '/uploads/KH/kh_coesfeld_logo.jpg'
          break
        case 'Wesel':
          khlogo = '/uploads/KH/kh_wesel_logo.jpg'
          break
        case 'Remscheid':
          khlogo = '/uploads/KH/kh_remscheid.jpg'
      }
      return khlogo
    }
  }
}
</script>
